import { isNil, isValid } from '@/helpers/values';

import { ICustomerState } from './state';

export default {
  token: (state: ICustomerState) => state.token.getSession().value,
  actaId: (state: ICustomerState) => state.customer.acta_user_id,
  isLogged: (state: ICustomerState) => isValid(state.customer.acta_user_id) && !state.isLoading,
  isLoading: (state: ICustomerState) => state.isLoading && !isNil(state.token.getSession().value),
  firstName: (state: ICustomerState) => {
    const firstName = (state.customer.name) ? state.customer.name.split(' ')[0] : '';

    return firstName;
  },
  deliveryAddress: (state: ICustomerState) => state.customer.delivery_address,
  rewardsSummary: (state: ICustomerState) => state.rewardsSummary,
  getCustomerLogged: (state: ICustomerState) => state.customer,
};
